<template>
  <div class="performance-overall-item">
    <icon-box
      :name="iconName"
      :variant="iconVariant"
      :background-color="iconBackgroundColor"
    ></icon-box>
    <div class="content">
      <div class="content__title">
        {{ title }}
      </div>
      <div class="content__value">
        {{ value }}
      </div>
    </div>
  </div>
</template>

<script>
import IconBox from '@components/dashboard-widgets/iconBox';

export default {
  components: { IconBox },
  props: {
    iconName: {
      type: String,
      default: 'cross',
    },
    iconVariant: {
      type: String,
      default: 'ffffff',
    },
    iconBackgroundColor: {
      type: String,
      default: 'black',
    },
    title: {
      type: String,
      default: 'Title',
    },
    value : {
      type: String,
      default: 'Value',
    },
  },
};
</script>

<style lang="scss" scoped>
.performance-overall-item {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 1rem;

  .content__title {
    font-size: rem-calc(11);
    font-weight: 600;
    color: #727272
  }

  .content__value {
    font-size: rem-calc(17);
    font-weight: 600;
    color: #232323;
  }
}

@media (min-width: 1201px) {
  .performance-overall-item {
    align-items: flex-start;
    line-height: normal;

    .content__title {
      font-size: rem-calc(17);
    }

    .content__value {
      font-size: rem-calc(44);
    }
  }
}
</style>
